jQuery(document).ready(function ($) {
  AOS.init({
    disable: 'phone',
    duration: 800,
    anchorPlacement: 'top-center',
  }); 
});
 